import { Button, TableHead } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: "rgb(11, 48, 149)",
}));

export const ModalContainer = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  padding: 16,
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  width: "90vw",
  maxWidth: 1000,
  maxHeight: "90vh",
  overflowY: "auto",
  [theme.breakpoints.down("sm")]: {
    width: "95vw",
    maxWidth: "none",
    top: "50%",
    left: "50%",
  },
}));

export const InputContainer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 16,
  marginBottom: 16,
  "& div": {
    marginBottom: 0,
    width: "100%",
  },

  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: 0,
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
}));
export const InputEquipmentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  gap: 8,
  alignItems: "center",
  "& div": {
    flexGrow: 1,
  },
  "& button": {
    fontSize: 12,
  },
  "& .MuiInputAdornment-root": {
    flexGrow: 0,
  },

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: 0,
    "& .MuiFormControl-root": {
      marginBottom: theme.spacing(1.5),
      width: "100%",
    },
    "& button": {
      width: "100%",
    },
  },

  [theme.breakpoints.between("sm", "md")]: {
    flexWrap: "wrap",
    "& .MuiFormControl-root, & button": {
      width: "calc(50% - 4px)",
    },
  },
}));

export const ButtonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 16,
  "& button": {
    marginLeft: 16,
  },
}));
export const ClientContainter = styled("div")(({ theme }) => ({
  "& h2": {
    fontWeight: 700,
  },
}));
export const EquipmentContainter = styled("div")(({ theme }) => ({
  marginTop: 16,
  "& h2": {
    fontWeight: 700,
  },
}));
export const EquipmentListContainter = styled("div")(({ theme }) => ({
  maxHeight: "40vh",
  overflow: "auto",
  padding: "12px 0",
}));
export const ButtonPdfContainerStyled = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  gap: theme.spacing(0.5),

  "& button": {
    alignSelf: "stretch",
  },

  "& .error-text": {
    minHeight: "18px",
    fontSize: "0.75rem",
    color: theme.palette.error.main,
    textAlign: "left",
    width: "100%",
  },
}));

export const ButtonStyled = styled(Button)(({ theme }) => ({
  maxHeight: "40px",
  height: 40,
  whiteSpace: "nowrap",
  marginTop: 12,
}));
